export * from './lib/pages/article/article.component';
